import { UserResponse } from '../client';

export class UserState {
  user: UserResponse | null = null;
  isLoggedIn: boolean = false;

  constructor() {
    // isLoggedIn will be set when user data is fetched from API
    this.isLoggedIn = false;
  }

  setUser(user: UserResponse | null) {
    this.user = user;
    // No localStorage storage - user will be fetched from API when needed
  }

  setLoggedIn(status: boolean) {
    this.isLoggedIn = status;
    if (!status) {
      this.logout();
    }
  }

  logout() {
    this.user = null;
    this.isLoggedIn = false;
  }
}
